import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button, { ButtonTypes } from 'components/common/button';
import ModalCard from 'components/common/modal_card';
import PortalModalWrapper from 'components/lib/portal_modal_wrapper';

function AgentOnCallWarningModal(props) {
  return (
    <PortalModalWrapper>
      <StyledModalCard data-aid="agentOnCallWarningModal" onClose={props.onClose}>
        <Header>
          <HeaderText>Agent currently on a call</HeaderText>
          <CloseButton aria-label="Close" onClick={props.onClose}>
            ×
          </CloseButton>
        </Header>
        <Body>
          <BodyText>
            This agent is currently connected to a live call. If you set them away, they will lose the ability to manage
            or end the call. Logging the agent out will end the call.
          </BodyText>
          <BodyText>
            Only proceed if you plan to log the agent out and end the call immediately after setting them away.
          </BodyText>
        </Body>
        <Footer>
          <Button buttonType={ButtonTypes.SECONDARY} onClick={props.onClose}>
            Cancel
          </Button>
          <Button buttonType={ButtonTypes.PRIMARY} onClick={props.onConfirm}>
            Set Away
          </Button>
        </Footer>
      </StyledModalCard>
    </PortalModalWrapper>
  );
}

AgentOnCallWarningModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default AgentOnCallWarningModal;

const StyledModalCard = styled(ModalCard)`
  &.modalCard-content {
    max-width: 550px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: var(--color-box-shadow-medium);
    padding: 0;
    margin: 0;
  }
`;

const Header = styled.div`
  background-color: ${p => p.theme.colors.green400};
  color: ${p => p.theme.colors.white};
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderText = styled.h2`
  font-size: ${p => p.theme.fontSize.medium};
  font-weight: ${p => p.theme.fontWeight.bold};
  margin: 0;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: ${p => p.theme.colors.white};
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const Body = styled.div`
  padding: 24px;
`;

const BodyText = styled.p`
  color: ${p => p.theme.colors.gray900};
  font-size: ${p => p.theme.fontSize.base};
  line-height: ${p => p.theme.lineHeight.base};
  margin: 0 0 16px 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Footer = styled.div`
  padding: 0 24px 24px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;
